import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { LoginFormContext } from "../login-form.context";
import { PrimaryButtonComponent } from "@gx1/gx-ui-common";
import styles from "./login-button.module.scss";

const LoginButton = ({ onSubmit, disabled = false }: { onSubmit: () => void; disabled?: boolean }) => {
  const { t } = useTranslation();
  const { isLoading } = useContext(LoginFormContext);

  return (
    <div className={styles.loginButton}>
      <PrimaryButtonComponent
        rootClassName={"gx-dragon-login-btn"}
        isLoading={isLoading}
        onClick={onSubmit}
        isDisabled={disabled}
      >
        {t("Get Started")}
      </PrimaryButtonComponent>
    </div>
  );
};
export default LoginButton;
